import gql from 'graphql-tag';

const UPDATE_USER = gql`
  mutation updateUser($data: UserInput!) {
    updateUser(data: $data) {
      id
      email
      firstName
      lastName
      profilePicture
      currentWorkspace
      superAdmin
    }
  }
`;

export default {
  UPDATE_USER,
};
